import { render } from "./document-upload-modal.vue?vue&type=template&id=0034f1b5"
import script from "./document-upload-modal.vue?vue&type=script&lang=js"
export * from "./document-upload-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__